import {
  Button,
  Col,
  Create,
  Row,
  SaveButton,
  useForm,
} from "@pankod/refine-antd";
import { IResourceComponentsProps, useNavigation } from "@pankod/refine-core";

import { FeatureFlagsForm } from "components/forms";
import { IFeatureFlagCreatePayload } from "interfaces/feature-flags";
import { FeatureFlagsHeaderBreadcrumb } from "./components/feature-flags-header-breadcrumb";
import {
  FEATURE_FLAGS_LIST_PATH,
  FEATURE_FLAGS_RESOURCE,
  FEATURE_FLAGS_TEXTS,
} from "./utils/feature-flags.constants";
import {
  buildFeatureFlagCreatePayload,
  FeatureFlagPayloadFormValues,
} from "./utils/feature-flags.payload";

export const FeatureFlagsCreate: React.FC<IResourceComponentsProps> = () => {
  const { push } = useNavigation();
  const { formProps, saveButtonProps, onFinish } =
    useForm<IFeatureFlagCreatePayload>({
      resource: FEATURE_FLAGS_RESOURCE,
      redirect: false,
      successNotification: {
        type: "success",
        message: FEATURE_FLAGS_TEXTS.successTitle,
        description: FEATURE_FLAGS_TEXTS.successMessage,
      },
      onMutationSuccess: () => push(FEATURE_FLAGS_LIST_PATH),
    });

  const handleFinish = (values: FeatureFlagPayloadFormValues) => {
    return onFinish(buildFeatureFlagCreatePayload(values));
  };

  return (
    <Create
      title={FEATURE_FLAGS_TEXTS.createTitle}
      saveButtonProps={saveButtonProps}
      breadcrumb={<FeatureFlagsHeaderBreadcrumb />}
      footerButtons={() => (
        <Row gutter={[6, 6]}>
          <Col>
            <Button
              onClick={() => push(FEATURE_FLAGS_LIST_PATH)}
              style={{ minWidth: "92px" }}
            >
              Cancelar
            </Button>
          </Col>
          <Col>
            <SaveButton
              {...saveButtonProps}
              icon={null}
              style={{ minWidth: "92px" }}
            >
              Incluir
            </SaveButton>
          </Col>
        </Row>
      )}
    >
      <FeatureFlagsForm
        formProps={{
          ...formProps,
          onFinish: handleFinish,
        }}
      />
    </Create>
  );
};
